module.exports = __webpack_public_path__ + "img/list-solid.239621cc.svg";